"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.weak-map.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.object.get-own-property-descriptor.js");

require("core-js/modules/es6.symbol.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteDonationFailure = exports.deleteDonationSuccess = exports.deleteDonationRequest = exports.editDonationFailure = exports.editDonationSuccess = exports.editDonationRequest = exports.addDonationFailure = exports.addDonationSuccess = exports.addDonationRequest = exports.invalidUploadDuration = exports.resetDirectorVideoUpload = exports.setUploadThumbnail = exports.setUploadProgress = exports.setUploadInProgress = exports.selectDirectorVideoFailure = exports.selectDirectorVideoSuccess = exports.selectDirectorVideoRequest = exports.deleteInviteFailure = exports.deleteInviteSuccess = exports.deleteInviteRequest = exports.editThemeFailure = exports.editThemeSuccess = exports.editThemeRequest = exports.editFuneralInfoReset = exports.editFuneralInfoFailure = exports.editFuneralInfoSuccess = exports.editFuneralInfoRequest = exports.editObituaryFailure = exports.editObituarySuccess = exports.editObituaryRequest = exports.addObituaryFailure = exports.addObituarySuccess = exports.addObituaryRequest = exports.addNoServiceOptionsFailure = exports.addNoServiceOptionsSuccess = exports.addNoServiceOptionsRequest = exports.deleteServiceSuccess = exports.deleteServiceFailure = exports.deleteServiceRequest = exports.getLocationsFailure = exports.getLocationsSuccess = exports.getLocationsRequest = exports.editServiceFailure = exports.editServiceSuccess = exports.editServiceRequest = exports.addServiceFailure = exports.addServiceSuccess = exports.addServiceRequest = exports.removeAccessorFailure = exports.removeAccessorSuccess = exports.resetDupeAccessorError = exports.removeAccessorRequest = exports.editAccessorFailure = exports.editAccessorSuccess = exports.editAccessorRequest = exports.addAccessorFailure = exports.addAccessorSuccess = exports.addAccessorRequest = exports.editDecedentPhoneSuccess = exports.editDecedentPhoneFailure = exports.editDecedentPhoneRequest = exports.editDecedentDetailsFailure = exports.editDecedentDetailsSuccess = exports.editDecedentDetailsRequest = exports.sendMemorialLinkReset = exports.sendMemorialLinkFailure = exports.sendMemorialLinkSuccess = exports.sendMemorialLinkRequest = exports.inviteReset = exports.finishInviteCreationFailure = exports.finishInviteCreationSuccess = exports.finishInviteCreationRequest = exports.fetchUnfinishedInviteFailure = exports.fetchUnfinishedInviteSuccess = exports.fetchUnfinishedInviteRequest = exports.startInviteCreationFailure = exports.startInviteCreationSuccess = exports.startInviteCreationRequest = exports.resetInviteCreationAction = void 0;

var types = _interopRequireWildcard(require("./constants"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Reset invite creation
var resetInviteCreationAction = {
  type: types.RESET_INVITE_CREATION
}; // Start Invite Creation

exports.resetInviteCreationAction = resetInviteCreationAction;

var startInviteCreationRequest = function startInviteCreationRequest() {
  return {
    type: types.START_INVITE_CREATION_REQUEST
  };
};

exports.startInviteCreationRequest = startInviteCreationRequest;

var startInviteCreationSuccess = function startInviteCreationSuccess(_ref) {
  var data = _ref.data;
  return {
    type: types.START_INVITE_CREATION_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.startInviteCreationSuccess = startInviteCreationSuccess;

var startInviteCreationFailure = function startInviteCreationFailure(error) {
  return {
    type: types.START_INVITE_CREATION_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Fetch Unfinished Invite


exports.startInviteCreationFailure = startInviteCreationFailure;

var fetchUnfinishedInviteRequest = function fetchUnfinishedInviteRequest() {
  return {
    type: types.FETCH_UNFINISHED_INVITE_REQUEST
  };
};

exports.fetchUnfinishedInviteRequest = fetchUnfinishedInviteRequest;

var fetchUnfinishedInviteSuccess = function fetchUnfinishedInviteSuccess(_ref2) {
  var data = _ref2.data;
  return {
    type: types.FETCH_UNFINISHED_INVITE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.fetchUnfinishedInviteSuccess = fetchUnfinishedInviteSuccess;

var fetchUnfinishedInviteFailure = function fetchUnfinishedInviteFailure(error) {
  return {
    type: types.FETCH_UNFINISHED_INVITE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Finish/Finalize Creation


exports.fetchUnfinishedInviteFailure = fetchUnfinishedInviteFailure;

var finishInviteCreationRequest = function finishInviteCreationRequest() {
  return {
    type: types.FINISH_INVITE_CREATION_REQUEST
  };
};

exports.finishInviteCreationRequest = finishInviteCreationRequest;

var finishInviteCreationSuccess = function finishInviteCreationSuccess(_ref3) {
  var data = _ref3.data;
  return {
    type: types.FINISH_INVITE_CREATION_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.finishInviteCreationSuccess = finishInviteCreationSuccess;

var finishInviteCreationFailure = function finishInviteCreationFailure(error) {
  return {
    type: types.FINISH_INVITE_CREATION_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.finishInviteCreationFailure = finishInviteCreationFailure;

var inviteReset = function inviteReset() {
  return {
    type: types.INVITE_SENT_RESET
  };
}; // Send Invite Preview SMS


exports.inviteReset = inviteReset;

var sendMemorialLinkRequest = function sendMemorialLinkRequest() {
  return {
    type: types.SEND_MEMORIAL_LINK_REQUEST
  };
};

exports.sendMemorialLinkRequest = sendMemorialLinkRequest;

var sendMemorialLinkSuccess = function sendMemorialLinkSuccess(_ref4) {
  var data = _ref4.data;
  return {
    type: types.SEND_MEMORIAL_LINK_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.sendMemorialLinkSuccess = sendMemorialLinkSuccess;

var sendMemorialLinkFailure = function sendMemorialLinkFailure(error) {
  return {
    type: types.SEND_MEMORIAL_LINK_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.sendMemorialLinkFailure = sendMemorialLinkFailure;

var sendMemorialLinkReset = function sendMemorialLinkReset() {
  return {
    type: types.SEND_MEMORIAL_LINK_RESET
  };
}; // Decedent Details


exports.sendMemorialLinkReset = sendMemorialLinkReset;

var editDecedentDetailsRequest = function editDecedentDetailsRequest() {
  return {
    type: types.EDIT_DECEDENT_DETAILS_REQUEST
  };
};

exports.editDecedentDetailsRequest = editDecedentDetailsRequest;

var editDecedentDetailsSuccess = function editDecedentDetailsSuccess(_ref5) {
  var data = _ref5.data;
  return {
    type: types.EDIT_DECEDENT_DETAILS_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editDecedentDetailsSuccess = editDecedentDetailsSuccess;

var editDecedentDetailsFailure = function editDecedentDetailsFailure(error) {
  return {
    type: types.EDIT_DECEDENT_DETAILS_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.editDecedentDetailsFailure = editDecedentDetailsFailure;

var editDecedentPhoneRequest = function editDecedentPhoneRequest() {
  return {
    type: types.EDIT_DECEDENT_PHONE_REQUEST
  };
};

exports.editDecedentPhoneRequest = editDecedentPhoneRequest;

var editDecedentPhoneFailure = function editDecedentPhoneFailure(error) {
  return {
    type: types.EDIT_DECEDENT_PHONE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.editDecedentPhoneFailure = editDecedentPhoneFailure;

var editDecedentPhoneSuccess = function editDecedentPhoneSuccess(_ref6) {
  var data = _ref6.data;
  return {
    type: types.EDIT_DECEDENT_PHONE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
}; // Accessors


exports.editDecedentPhoneSuccess = editDecedentPhoneSuccess;

var addAccessorRequest = function addAccessorRequest() {
  return {
    type: types.ADD_NEW_ACCESSOR_REQUEST
  };
};

exports.addAccessorRequest = addAccessorRequest;

var addAccessorSuccess = function addAccessorSuccess(_ref7) {
  var data = _ref7.data;
  return {
    type: types.ADD_NEW_ACCESSOR_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.addAccessorSuccess = addAccessorSuccess;

var addAccessorFailure = function addAccessorFailure(error) {
  return {
    type: types.ADD_NEW_ACCESSOR_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.addAccessorFailure = addAccessorFailure;

var editAccessorRequest = function editAccessorRequest() {
  return {
    type: types.EDIT_ACCESSOR_REQUEST
  };
};

exports.editAccessorRequest = editAccessorRequest;

var editAccessorSuccess = function editAccessorSuccess(_ref8) {
  var data = _ref8.data;
  return {
    type: types.EDIT_ACCESSOR_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editAccessorSuccess = editAccessorSuccess;

var editAccessorFailure = function editAccessorFailure(error) {
  return {
    type: types.EDIT_ACCESSOR_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.editAccessorFailure = editAccessorFailure;
var removeAccessorRequest = {
  type: types.DELETE_ACCESSOR_REQUEST
};
exports.removeAccessorRequest = removeAccessorRequest;
var resetDupeAccessorError = {
  type: types.RESET_DUPE_ACCESSOR_ERROR
};
exports.resetDupeAccessorError = resetDupeAccessorError;

var removeAccessorSuccess = function removeAccessorSuccess(_ref9) {
  var data = _ref9.data;
  return {
    type: types.DELETE_ACCESSOR_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.removeAccessorSuccess = removeAccessorSuccess;

var removeAccessorFailure = function removeAccessorFailure(error) {
  return {
    type: types.DELETE_ACCESSOR_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Services


exports.removeAccessorFailure = removeAccessorFailure;

var addServiceRequest = function addServiceRequest() {
  return {
    type: types.ADD_NEW_SERVICE_REQUEST
  };
};

exports.addServiceRequest = addServiceRequest;

var addServiceSuccess = function addServiceSuccess(_ref10) {
  var data = _ref10.data;
  return {
    type: types.ADD_NEW_SERVICE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.addServiceSuccess = addServiceSuccess;

var addServiceFailure = function addServiceFailure(error) {
  return {
    type: types.ADD_NEW_SERVICE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.addServiceFailure = addServiceFailure;

var editServiceRequest = function editServiceRequest() {
  return {
    type: types.EDIT_SERVICE_REQUEST
  };
};

exports.editServiceRequest = editServiceRequest;

var editServiceSuccess = function editServiceSuccess(_ref11) {
  var data = _ref11.data;
  return {
    type: types.EDIT_SERVICE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editServiceSuccess = editServiceSuccess;

var editServiceFailure = function editServiceFailure(error) {
  return {
    type: types.EDIT_SERVICE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.editServiceFailure = editServiceFailure;

var getLocationsRequest = function getLocationsRequest() {
  return {
    type: types.GET_LOCATIONS_REQUEST
  };
};

exports.getLocationsRequest = getLocationsRequest;

var getLocationsSuccess = function getLocationsSuccess(_ref12) {
  var data = _ref12.data;
  return {
    type: types.GET_LOCATIONS_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.getLocationsSuccess = getLocationsSuccess;

var getLocationsFailure = function getLocationsFailure(error) {
  return {
    type: types.GET_LOCATIONS_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.getLocationsFailure = getLocationsFailure;
var deleteServiceRequest = {
  type: types.DELETE_SERVICE_REQUEST
};
exports.deleteServiceRequest = deleteServiceRequest;

var deleteServiceFailure = function deleteServiceFailure(error) {
  return {
    type: types.DELETE_SERVICE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.deleteServiceFailure = deleteServiceFailure;

var deleteServiceSuccess = function deleteServiceSuccess(_ref13) {
  var data = _ref13.data;
  return {
    type: types.DELETE_SERVICE_SUCCESS,
    receivedAt: Date.now(),
    payload: data
  };
};

exports.deleteServiceSuccess = deleteServiceSuccess;
var addNoServiceOptionsRequest = {
  type: types.ADD_NOSERVICE_OPTIONS_REQUEST
};
exports.addNoServiceOptionsRequest = addNoServiceOptionsRequest;

var addNoServiceOptionsSuccess = function addNoServiceOptionsSuccess(_ref14) {
  var data = _ref14.data;
  return {
    type: types.ADD_NOSERVICE_OPTIONS_SUCCESS,
    receivedAt: Date.now(),
    payload: data
  };
};

exports.addNoServiceOptionsSuccess = addNoServiceOptionsSuccess;

var addNoServiceOptionsFailure = function addNoServiceOptionsFailure(error) {
  return {
    type: types.ADD_NOSERVICE_OPTIONS_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Obituary


exports.addNoServiceOptionsFailure = addNoServiceOptionsFailure;

var addObituaryRequest = function addObituaryRequest() {
  return {
    type: types.ADD_OBITUARY_REQUEST
  };
};

exports.addObituaryRequest = addObituaryRequest;

var addObituarySuccess = function addObituarySuccess(_ref15) {
  var data = _ref15.data;
  return {
    type: types.ADD_OBITUARY_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.addObituarySuccess = addObituarySuccess;

var addObituaryFailure = function addObituaryFailure(error) {
  return {
    type: types.ADD_OBITUARY_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.addObituaryFailure = addObituaryFailure;

var editObituaryRequest = function editObituaryRequest() {
  return {
    type: types.EDIT_OBITUARY_REQUEST
  };
};

exports.editObituaryRequest = editObituaryRequest;

var editObituarySuccess = function editObituarySuccess(_ref16) {
  var data = _ref16.data;
  return {
    type: types.EDIT_OBITUARY_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editObituarySuccess = editObituarySuccess;

var editObituaryFailure = function editObituaryFailure(error) {
  return {
    type: types.EDIT_OBITUARY_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Provider / Funeral Info


exports.editObituaryFailure = editObituaryFailure;

var editFuneralInfoRequest = function editFuneralInfoRequest() {
  return {
    type: types.EDIT_FUNERAL_INFO_REQUEST
  };
};

exports.editFuneralInfoRequest = editFuneralInfoRequest;

var editFuneralInfoSuccess = function editFuneralInfoSuccess(_ref17) {
  var data = _ref17.data;
  return {
    type: types.EDIT_FUNERAL_INFO_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editFuneralInfoSuccess = editFuneralInfoSuccess;

var editFuneralInfoFailure = function editFuneralInfoFailure(error) {
  return {
    type: types.EDIT_FUNERAL_INFO_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.editFuneralInfoFailure = editFuneralInfoFailure;

var editFuneralInfoReset = function editFuneralInfoReset() {
  return {
    type: types.EDIT_FUNERAL_INFO_RESET
  };
}; // Theme


exports.editFuneralInfoReset = editFuneralInfoReset;

var editThemeRequest = function editThemeRequest() {
  return {
    type: types.EDIT_THEME_REQUEST
  };
};

exports.editThemeRequest = editThemeRequest;

var editThemeSuccess = function editThemeSuccess(_ref18) {
  var data = _ref18.data;
  return {
    type: types.EDIT_THEME_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editThemeSuccess = editThemeSuccess;

var editThemeFailure = function editThemeFailure(error) {
  return {
    type: types.EDIT_THEME_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Delete Invite


exports.editThemeFailure = editThemeFailure;

var deleteInviteRequest = function deleteInviteRequest() {
  return {
    type: types.DELETE_INVITE_REQUEST
  };
};

exports.deleteInviteRequest = deleteInviteRequest;

var deleteInviteSuccess = function deleteInviteSuccess(_ref19) {
  var data = _ref19.data;
  return {
    type: types.DELETE_INVITE_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.deleteInviteSuccess = deleteInviteSuccess;

var deleteInviteFailure = function deleteInviteFailure(error) {
  return {
    type: types.DELETE_INVITE_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // select Director Video


exports.deleteInviteFailure = deleteInviteFailure;

var selectDirectorVideoRequest = function selectDirectorVideoRequest() {
  return {
    type: types.SELECT_DIRECTOR_VIDEO_REQUEST
  };
};

exports.selectDirectorVideoRequest = selectDirectorVideoRequest;

var selectDirectorVideoSuccess = function selectDirectorVideoSuccess(_ref20) {
  var data = _ref20.data;
  return {
    type: types.SELECT_DIRECTOR_VIDEO_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.selectDirectorVideoSuccess = selectDirectorVideoSuccess;

var selectDirectorVideoFailure = function selectDirectorVideoFailure(error) {
  return {
    type: types.SELECT_DIRECTOR_VIDEO_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
}; // Upload Director Video


exports.selectDirectorVideoFailure = selectDirectorVideoFailure;

var setUploadInProgress = function setUploadInProgress(isInProgress) {
  return {
    type: types.SET_UPLOAD_IN_PROGRESS,
    payload: isInProgress
  };
};

exports.setUploadInProgress = setUploadInProgress;

var setUploadProgress = function setUploadProgress(progress) {
  return {
    type: types.SET_UPLOAD_PROGRESS,
    payload: progress
  };
};

exports.setUploadProgress = setUploadProgress;

var setUploadThumbnail = function setUploadThumbnail(thumbnailUrl) {
  return {
    type: types.SET_UPLOAD_THUMBNAIL,
    payload: thumbnailUrl
  };
};

exports.setUploadThumbnail = setUploadThumbnail;

var resetDirectorVideoUpload = function resetDirectorVideoUpload(thumbnailUrl) {
  return {
    type: types.RESET_DIRECTOR_VIDEO_UPLOAD,
    payload: thumbnailUrl
  };
};

exports.resetDirectorVideoUpload = resetDirectorVideoUpload;

var invalidUploadDuration = function invalidUploadDuration(message) {
  return {
    type: types.INVALID_DIRECTOR_UPLOAD_DURATION,
    payload: message
  };
}; // Donation


exports.invalidUploadDuration = invalidUploadDuration;

var addDonationRequest = function addDonationRequest() {
  return {
    type: types.ADD_DONATION_REQUEST
  };
};

exports.addDonationRequest = addDonationRequest;

var addDonationSuccess = function addDonationSuccess(_ref21) {
  var data = _ref21.data;
  return {
    type: types.ADD_DONATION_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.addDonationSuccess = addDonationSuccess;

var addDonationFailure = function addDonationFailure(error) {
  return {
    type: types.ADD_DONATION_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.addDonationFailure = addDonationFailure;

var editDonationRequest = function editDonationRequest() {
  return {
    type: types.EDIT_DONATION_REQUEST
  };
};

exports.editDonationRequest = editDonationRequest;

var editDonationSuccess = function editDonationSuccess(_ref22) {
  var data = _ref22.data;
  return {
    type: types.EDIT_DONATION_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.editDonationSuccess = editDonationSuccess;

var editDonationFailure = function editDonationFailure(error) {
  return {
    type: types.EDIT_DONATION_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.editDonationFailure = editDonationFailure;

var deleteDonationRequest = function deleteDonationRequest() {
  return {
    type: types.DELETE_DONATION_REQUEST
  };
};

exports.deleteDonationRequest = deleteDonationRequest;

var deleteDonationSuccess = function deleteDonationSuccess(_ref23) {
  var data = _ref23.data;
  return {
    type: types.DELETE_DONATION_SUCCESS,
    payload: data,
    receivedAt: Date.now()
  };
};

exports.deleteDonationSuccess = deleteDonationSuccess;

var deleteDonationFailure = function deleteDonationFailure(error) {
  return {
    type: types.DELETE_DONATION_FAILURE,
    error: error,
    receivedAt: Date.now()
  };
};

exports.deleteDonationFailure = deleteDonationFailure;